import { isAfter } from 'date-fns'

export const isExpired = (cardExpireDate: string | null | undefined) => {
  if (!cardExpireDate) {
    return false
  }

  return isAfter(new Date(), new Date(cardExpireDate))
}
